import { MessageAlertIcon } from './MessageAlertIcon';

/**
 * author: Google
 * id 213A797A-41C0-4804-A5B1-A841898CCC11
 * name message-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-alert.svg
 * tags
 * - Alert / Error 
 */
export const SmsFailedIcon = MessageAlertIcon;
export default SmsFailedIcon